// ** Third Party Components
import styled, { css } from "styled-components";

export const StyledSvgIconContainer = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 18px;
	margin: 0 0.5rem 0 0;

	${({ $customMargin }) =>
		$customMargin &&
		css`
			margin: ${$customMargin};
		`}

	${({ $customWidth }) =>
		$customWidth &&
		css`
			width: ${$customWidth};
		`}

	svg {
		fill: ${({ theme: { colors } }) => colors.whiteAlways};
		display: block;
		height: 1em;

		${({ $customHeight }) =>
			$customHeight &&
			css`
				height: ${$customHeight};
			`};

		${({ $customVerticalAlign }) =>
			$customVerticalAlign &&
			css`
				vertical-align: ${$customVerticalAlign};
			`};
	}
`;
const SexIcon = ({
	customHeight,
	customMargin,
	customVerticalAlign,
	customWidth,
}) => {
	return (
		<StyledSvgIconContainer
			$customHeight={customHeight}
			$customMargin={customMargin}
			$customVerticalAlign={customVerticalAlign}
			$customWidth={customWidth}
		>
			<svg
				viewBox="0 0 11 14"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M5.49736 0.415664C5.51851 0.54418 5.92308 2.99965 5.92308 3.93754C5.92308 5.36762 5.18798 6.38754 4.1012 6.7977L4.44231 13.3082C4.46082 13.6829 4.1726 14 3.80769 14H2.11538C1.75313 14 1.46226 13.6856 1.48077 13.3082L1.82188 6.7977C0.732452 6.38754 0 5.36488 0 3.93754C0 2.99691 0.404567 0.54418 0.425721 0.415664C0.510337 -0.139414 1.62356 -0.147617 1.69231 0.445742V4.30668C1.72668 4.39965 2.09159 4.39418 2.11538 4.30668C2.1524 3.61488 2.32428 0.50043 2.32692 0.429336C2.41418 -0.139414 3.50889 -0.139414 3.59351 0.429336C3.5988 0.503164 3.76803 3.61488 3.80505 4.30668C3.82885 4.39418 4.19639 4.39965 4.22813 4.30668V0.445742C4.29688 -0.144883 5.41274 -0.139414 5.49736 0.415664ZM8.64928 8.22777L8.25264 13.2891C8.22091 13.6719 8.51442 14 8.88462 14H10.3654C10.7171 14 11 13.7075 11 13.3438V0.656289C11 0.295352 10.7171 3.90812e-05 10.3654 3.90812e-05C8.18389 3.90812e-05 4.51106 4.8809 8.64928 8.22777Z"
					fill="#568DFD"
				/>
			</svg>
		</StyledSvgIconContainer>
	);
};

export default SexIcon;
